<template>
<div>
  <div class="recruit">
    <div class="box" v-bind:style="background">
      <Title :title="title" :message="message"/>
    </div>
    <div class="recruit-top">
      <div class="toptitle">
        <h1>採用情報</h1>
      </div>
    </div>
    <div class="link">
      <router-link class="box6" to="/new">
        <p>新卒採用</p>
        <div class="arrow01"></div>
      </router-link>
      <router-link class="box6" to="/driver">
        <p>バス運転士採用</p>
        <div class="arrow02"></div>
      </router-link>
    </div>
  </div>
</div>
</template>

<script>
import Title from '@/components/Title.vue'

export default {
  components: {
    Title
  },
  data () {
    return {
      background: {
        background: '',
        position: 'relative',
        height: '100vh',
        minHeight: '300px',
        backgroundSize: 'cover',

        display: 'flex',
        flexDirection: 'column',

        letterSpacing: '0',
        color: '#FFFFFF'
      },
      title: 'RECRUIT',
      message: '勇気を持った、あなたを待っています。'
    }
  },
  created () {
    this.background.background = "url('" + require('../assets/recruit-top.jpg') + "') no-repeat 70% 50%"
  }
}
</script>

<style scoped>
.recruit {
  overflow:hidden;
}
.recruit-top {
  padding: 2% 4% 4% 4%;
}
h1 {
  font-size: 32px;
  font-weight: bold;
  padding: 20px 15px;
  margin: 0px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: #a6a6a6;
  color: #000000;
}
.link {
  padding: 2% 4% 4% 4%;
  display: flex;
}
.box6 {
  border:2px solid #a6a6a6;
  padding:5px 14px;
  background:#FFF 0% 0% no-repeat padding-box;
  right:9px;
  bottom:27px;
  width:500px;
  min-width:170px;
  display:flex;
  justify-content:center;
  align-items:center;
  margin:0 auto;
}
.box6 p {
  font-size: 20px;
  font-weight: 600;
  color: #000;
  margin: 0;
  padding: 0;
}
.arrow01 {
  display: block;
  width: 12px;
  height: 12px;
  border-top: solid 3px #7E7474;
  border-right: solid 3px #7E7474;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  right: 60%;
}
.arrow02 {
  display: block;
  width: 12px;
  height: 12px;
  border-top: solid 3px #7E7474;
  border-right: solid 3px #7E7474;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  right: 13%;
}
@media screen and (max-width: 480px) {
  .link {
    padding: 2% 4% 4% 4%;
    display: flex;
    flex-flow: column;
  }
  .box6 {
    border:2px solid #a6a6a6;
    padding:5px 14px;
    background:#FFF 0% 0% no-repeat padding-box;
    right:9px;
    bottom:27px;
    width:300px;
    min-width:170px;
    display:flex;
    justify-content:center;
    align-items:center;
    margin:10px 10px 10px 30px;
  }
  .arrow01 {
    display: block;
    width: 12px;
    height: 12px;
    border-top: solid 3px #7E7474;
    border-right: solid 3px #7E7474;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    position: absolute;
    right: 20%;
  }
  .arrow02 {
    display: block;
    width: 12px;
    height: 12px;
    border-top: solid 3px #7E7474;
    border-right: solid 3px #7E7474;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    position: absolute;
    right: 20%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Recruit.vue